import React from "react";
import { Label, FormGroup, Input } from "reactstrap";
import { IRadioButtonProps } from "../../../interfaces/Index";

import "./RadioButton.scss";

const RadioButton: React.FunctionComponent<IRadioButtonProps> = ({
  ...props
}) => {
  const renderRadioButtons = () => {
    if (props.radioButtonArray && props.radioButtonArray.length > 0) {
      return props.radioButtonArray.map((radioButton, index) => (
        <FormGroup check className="radio-button-body" key={index}>
          <div>
            <div className="inline-block">
              <label>
                <Input
                  type="radio"
                  name={radioButton.name}
                  value={radioButton.value}
                  checked={radioButton.checked}
                  onClick={(e) => props.onChange(e, index)}
                  disabled={props.isDisabled}
                />{" "}
                <span className="checkmark"></span>
                <div className="button-text">{radioButton.buttonText}</div>
              </label>
            </div>
          </div>
        </FormGroup>
      ));
    }
  };

  return (
    <div className="form-group">
      <Label className="block text-uppercase label text-left">
        {props.label}
      </Label>
      {renderRadioButtons()}
    </div>
  );
};

RadioButton.defaultProps = {
  isDisabled: false
}

export default RadioButton;
